import React, { useEffect } from 'react';
import { CheckCircle, X } from 'lucide-react';
interface ToastProps {
  message: string;
  isVisible: boolean;
  onClose: () => void;
}
export function Toast({
  message,
  isVisible,
  onClose
}: ToastProps) {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);
  if (!isVisible) return null;
  return <div className="fixed top-6 right-6 z-50 animate-in slide-in-from-top-2 fade-in duration-300" data-id="element-144">
      <div className="bg-white rounded-lg shadow-xl border border-gray-200 p-4 flex items-center gap-3 min-w-[320px]" data-id="element-145">
        <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-146">
          <CheckCircle className="w-5 h-5 text-green-600" data-id="element-147" />
        </div>
        <p className="text-sm font-medium text-gray-900 flex-1" data-id="element-148">{message}</p>
        <button onClick={onClose} className="p-1 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-149">
          <X className="w-4 h-4" data-id="element-150" />
        </button>
      </div>
    </div>;
}